import { ThemeIcon, NavLink } from '@mantine/core';
import { IconReport } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums';

interface UsersLinkProps {
  navigate(to: string): void;
  themeColor: 'dark' | 'light';
}

export function ReportsLink({ navigate, themeColor }: UsersLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: themeColor === 'light' ? '#373A40' : '#FBFBFB',
        },
      }}
      label="Relatórios"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="violet" variant="light">
          <IconReport size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Pedidos"
        onClick={() => navigate(AppRoutePaths.REPORT_ORDERS)}
      />
      <NavLink
        label="Atividades"
        onClick={() => navigate(AppRoutePaths.ORDER_ACTIVITIES_SUMMARY)}
      />
      <NavLink
        label="Arte Final"
        onClick={() => navigate(AppRoutePaths.REPORTS_ART)}
      />
      <NavLink
        label="Produção"
        onClick={() => navigate(AppRoutePaths.REPORTS_PRODUCTION)}
      />
      <NavLink
        label="Manuseio"
        onClick={() => navigate(AppRoutePaths.REPORTS_HANDLING)}
      />
      <NavLink
        label="Pagamentos"
        onClick={() => navigate(AppRoutePaths.REPORTS_PAYMENTS)}
      />
      <NavLink
        label="Evento"
        onClick={() => navigate(AppRoutePaths.REPORTS_EVENTS)}
      />
    </NavLink>
  );
}
